import React from 'react';
import { LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
export function TopBar() {
  return <header className="sticky top-0 z-50 border-b border-slate-200 bg-white/95 shadow-sm backdrop-blur" data-id="element-365" data-mp="232nfsn0fptzi">
      <div className="bg-sky-600 px-3 py-1.5 text-center text-[10px] font-extrabold uppercase tracking-wide text-white sm:text-xs md:text-sm" data-id="element-366" data-mp="1y4vfb4lq4zjp">
        🇦🇷 EL SISTEMA COMPLETO PARA CREAR MUEBLES FÁCILES EN CASA
      </div>
      <div className="mx-auto hidden max-w-5xl items-center justify-center gap-7 py-2 text-xs font-semibold text-slate-600 md:flex" data-id="element-367" data-mp="2qrycntenz48d">
        <span className="flex items-center gap-1.5" data-id="element-368" data-mp="2h2ohu5sfr7gk">
          <ZapIcon className="h-3.5 w-3.5 text-sky-600" data-id="element-369" data-mp="2h1dci1jcdrnc" /> Acceso digital inmediato
        </span>
        <span className="text-slate-300" data-id="element-370" data-mp="2c2sf09vh5m2l">·</span>
        <span className="flex items-center gap-1.5" data-id="element-371" data-mp="39iz8i8khmjnp">
          <LockIcon className="h-3.5 w-3.5 text-sky-600" data-id="element-372" data-mp="39jr0zaisg19r" /> Pago seguro
        </span>
        <span className="text-slate-300" data-id="element-373" data-mp="34r7pcj3nvg7l">·</span>
        <span className="flex items-center gap-1.5" data-id="element-374" data-mp="34qfrt2qi78eo">
          <ShieldCheckIcon className="h-3.5 w-3.5 text-sky-600" data-id="element-375" data-mp="26ix60bpa54v" /> Garantía de 7 días
        </span>
      </div>
    </header>;
}